import angular from 'angular';

import rEditablePickerWithDefault from '../../react/components/EditablePickerWithDefaultAngular';

import directives from './directives';
import filters from './filters';
import security from './security';
import services from './services';
import components from './components';
import AllModelsImport from './AllModels';

const componentsModule = angular.module('components', [
  directives,
  filters,
  security,
  services,
  components,
]);

componentsModule
  .component('rEditablePickerWithDefault', rEditablePickerWithDefault)
  .factory('AllModels', AllModelsImport);

export default componentsModule.name;
